import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {program, task} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    icon: CheckIcon,
    iconGradient: 'success',
    title: i18n.t('notifications:task_pending.title', {
      taskTitle: task?.title,
    }),
  };
};
